// src/data/contactSectionComponentData.js (Arabic)
const contactSectionComponentArabic = {
  heading: "الخلاصة هي <br /> <span>نحن ننجز المهمة!</span>",
  skilledTalent: {
    title: "شبكة المواهب الماهرة",
    description: "يتكون فريقنا من محترفين ذوي خبرة عالية.",
  },
  swiftTurnaround: {
    title: "سرعة الإنجاز",
    description: "نقدم حلولاً سريعة وفعالة على الرغم من ضيق الوقت.",
  },
  costEffective: {
    title: "حلول فعالة من حيث التكلفة",
    description: "نقدم خدمات عالية الجودة تزيد من إمكانات ميزانيتك.",
  },
  innovationDriven: {
    title: "تطوير مدفوع بالابتكار",
    description: "نركز على تقديم حلول متطورة ومبتكرة ومصممة خصيصًا.",
  },
  contactEmails: [
    {
      text: "hello@bitsclan.com",
      href: "mailto:hello@bitsclan.com",
      icon: "/images/SVG/email-icon.png",
    },
  ],
  helloEmails: [
    {
      text: "hello@bitsclan.com",
      href: "hello@bitsclan.com",
      icon: "/images/SVG/email-icon.png",
    },
  ],
  contactPhones: [
    {
      text: "+1 315 666 8052",
      href: "tel:+13156668052",
      icon: "/images/SVG/Phone.svg",
    },
  ],
  recaptchaSiteKey: "6LduktkqAAAAAAG-TJxQPKptt1p5F4l_FYqYqNgv",
  thankYouVideo: "/videos/thankyou-vedio.mp4",
  calendlyLink: "https://calendly.com/bitsclan-it/30min?month=2025-01",
  servicesOptions: [
    { value: "Software Development", label: "تطوير البرمجيات" },
    { value: "UI/UX", label: "تصميم واجهة المستخدم/تجربة المستخدم" },
    { value: "QA", label: "ضمان الجودة" },
    { value: "Integration", label: "التكامل" },
    { value: "Maintenance", label: "الصيانة" },
    { value: "Consultancy", label: "الاستشارات" },
  ],
  formLabels: {
    fullName: "الاسم الكامل",
    email: "البريد الإلكتروني",
    phoneNumber: "رقم الهاتف",
    services: "الخدمات",
    aboutProject: "أخبرنا عن مشروعك",
    attachFile: "إرفاق ملف (اختياري)",
    submitButton: "إرسال",
    requiredSymbol: "*",
  },

  // CONTACT US PAGE FORM DATA
  contactUsFormStaticData: {
    firstName: {
      label: "الاسم الأول",
      placeholder: "أدخل اسمك الأول هنا",
    },
    phone: {
      label: "اسم العائلة",
      placeholder: "أدخل اسم العائلة هنا",
    },
    email: {
      label: "البريد الإلكتروني",
      placeholder: "أدخل بريدك الإلكتروني هنا",
    },
    companyName: {
      label: "اسم الشركة",
      placeholder: "أدخل اسم شركتك هنا",
    },
    aboutProject: {
      label: "نبذة عن مشروعك",
      placeholder: "أخبرنا المزيد عن مشروعك*",
    },
    nda: {
      label: "هل تحتاج إلى اتفاقية عدم إفشاء (NDA) أولاً؟",
      options: ["نعم", "لا"],
    },
    services: {
      placeholder: "الخدمات",
    },
    submitButton: {
      buttonText: "طلب تقدير مجاني",
      loadingText: "جارٍ التحميل...",
    },
  },
  servicesArray: [
    {
      value: "Web Application Development",
      label: "تطوير تطبيقات الويب",
    },
    {
      value: "AI Development",
      label: "تطوير الذكاء الاصطناعي",
    },
    {
      value: "Custom Development",
      label: "التطوير المخصص",
    },
    {
      value: "Mobile App Development",
      label: "تطوير تطبيقات الهاتف المحمول",
    },
    {
      value: "DevOps Services",
      label: "خدمات ديف أوبس",
    },
    // {
    //   value: "Quality Assurance Services",
    //   label: "خدمات ضمان الجودة",
    // },
    // {
    //   value: "Data Analytics",
    //   label: "تحليلات البيانات",
    // },
    {
      value: "BlockChain Development",
      label: "تطوير البلوك تشين",
    },
    // {
    //   value: "Cyber Security",
    //   label: "الأمن السيبراني",
    // },
  ],
};

export default contactSectionComponentArabic;
